import React from 'react'
import { IconsProps } from 'msp-integrations'

const ChatIcon = (props: IconsProps) => {
  return (
    <svg {...props} viewBox='0 0 24 22' xmlns='http://www.w3.org/2000/svg'>
      <path d="M7.398 21.087v-4.941H.97V2.769A2.585 2.585 0 0 1 3.552.19h19.803v13.373a2.583 2.583 0 0 1-2.58 2.581h-8.447l-4.93 4.944Zm-5.618-5.75h6.427v3.794l3.786-3.794h8.781c.977 0 1.772-.796 1.772-1.772V1H3.552c-.976 0-1.772.796-1.772 1.772v12.565Z" />
    </svg>
  )
}

export default ChatIcon
